module.exports = __webpack_public_path__ + "img/model1.264116e2.jpg";